import { render, staticRenderFns } from "./TourDialog.vue?vue&type=template&id=f13ae6b8"
import script from "./TourDialog.js?vue&type=script&lang=js&external"
export * from "./TourDialog.js?vue&type=script&lang=js&external"
import style0 from "./TourDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSlideYReverseTransition,VSnackbar})
